import React from 'react';
import { TransverseLoading } from 'react-loadingg';
import { LoaderContainer, Div } from './Styles';

/* Componente loader de carga  */

/*
 * @param  {} isLoading: Contiene el estado de si está o no cargando
 */
const FullPageLoader = ({ isLoading }) => {
  return (
    isLoading
      ? <LoaderContainer>
        <Div>
          <TransverseLoading size='large' color='#0C3967' />
        </Div>
      </LoaderContainer>
      : null
  );
};

export default FullPageLoader;
